<template>
  <div class="accept-container" v-title :data-title="this.$t('title.all')+this.$t('title.doc')">
    <Navbar></Navbar>
    <div class="iframe">
      <iframe  id="showIframe"
               width="100%"
               height="100%"
               frameborder=0 
               name="showHere" 
               scrolling=auto
               :src='this.url'></iframe>
      <div class="progress" v-if="status==1">
        <el-progress  :stroke-width="20"
                      :show-text="false"
                      :percentage="progress"
                      color="#5cb85c"></el-progress>
        <div class="progress-html">{{progresshtml}}</div>
      </div>
      <!-- {{$t('read.over_button')}} -->
      <div class="look-all" 
           v-if="status !=1"
           @click="lookAll">
           {{$t('fanyi.downAllDoc')}}
           <!-- <img src="../assets/down-icon.png" alt="" /> -->
           </div>
    </div>
    <PayVipComponent ref="payvip"></PayVipComponent>
  </div>
</template>
<style scoped>
  @import "../css/progress-line.scss";
  .iframe{
    height: 95vh;
    position: relative;
    max-width: 1000px;
    margin: 0 auto 50px;;
    /* margin-bottom:50px; */
  }
  .look-all{
    position: absolute;
    /* width: 50px;
    border-radius: 50px;
    height: 50px;
    cursor: pointer;
    bottom:30px;
    right:30px;
    border-radius: 50%; */

    left:50%;
    transform: translateX(-50%);
    text-align: center;
    color: #fff;
    background: #5ebb8d;
    width: 200px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    border-radius: 5px;
    bottom: 40px;
    /* box-shadow: 1px 1px 1px 3px #e0e0e0,
                -1px -1px 1px 3px #e0e0e0,
                1px -1px 1px 3px #e0e0e0,
                -1px 1px 1px 3px #e0e0e0; */
  }
  .look-all:hover{
    background: #4CA177;
  }
  /* .look-all>img{
    display: block;
    width: 100%;
  } */
  .progress{
    height: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .progress .progress-html{
    position: absolute;
    font-size: 12px;
    color: #ffffff;
    left: 50%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translate(-50%,-50%);
  }
    @media (max-width: 650px) {
      .iframe{
        margin-bottom:0px;
        height: 100vh;
      }
   }
</style>
<script>
  import {getStatus, getPreView,getReadView ,handleOpen} from '@/api/doc'
  import { USER_INFO,payDoc } from '@/api/user'
  import{isPhone} from '@/api/public'
  import Navbar from '../components/Navbar'
  import hostUrl from '../config/config'
  import PayVipComponent  from '../components/PayVipComponent';
  import { setTimeout } from 'timers';

  let timeOut = null;
  let first=true;
  export default {
    name: 'hello',
    components:{
        Navbar,
        PayVipComponent},
    data() {
      return {
          url: '',
          progresshtml:'',
          docId:'',
          progress:0,
          status:0,
          content_html:'',
          user:{}
      }
    },
    mounted() {
      this.docId = this.$route.params.id;
      this.getPdfStatus(this.docId);
      this.getReadView(this.docId);
      // this.getPreView(this.docId); 
    },
    beforeDestroy(){
      clearInterval(timeOut);
      timeOut = null;
    },
    created(){
        this.user = USER_INFO();
    },
    methods: {
        getReadView:function(id){
            const host = window.location.hostname !== 'localhost'? window.location.origin:'http://localhost:8080';
            console.log(host);
            const fileURL = encodeURIComponent(hostUrl.NEW_TRS_URL+ "/v1/doc/" + this.docId + "/read?type=pdf&date="+Date.parse(new Date()));
            this.url = host+'/fanyi/pdf/web/viewer.html?file=' + fileURL;
            setTimeout(()=>{
              const ifarme = window.document.getElementById('showIframe');
              // console.log(ifarme.contentWindow.document.getElementById('lookAll'));
              console.log(ifarme);
              console.log(window.PDFViewerApplication)
            },1000)
        },
        getPreView:function(id) {
            getPreView(this.user._id, id).then(res=>{
                if(res.rc === 0 ){
                    this.getReadView(this.docId);
                }else if(res.rc === -1 ){
                    console.log('用户失败')
                }else{
                    console.log('其他失败情况')
                }
            })
        },
        getPdfStatus:function(id) {
            timeOut =setInterval(()=>{
              getStatus(id).then(res=>{
                if (res.rc == 0 && res.preview_status == 2) {
                    this.status = res.status;
                  if (res.status == 2) {
                    this.progress = 100;
                    this.progresshtml=this.$t('fanyi.message.ts_ok');
                    clearInterval(timeOut);
                    timeOut = null;
                    if(first){
                      this.status = 0
                    }else{
                      this.status = 2
                    }
                  } else if (res.status == 3 || res.status== -1) {
                    clearInterval(timeOut);
                    timeOut = null;
                    this.showAlertError(`${this.$t('fanyi.message.ts_fail')}`);
                  } else if(res.status ==4){
                    clearInterval(timeOut);
                    timeOut = null;
                    this.showAlertError(`${this.$t('fanyi.message.changePdf')}`);
                  }else{
                    this.progress = res.progress || 0;
                    this.progresshtml=`${this.$t('fanyi.message.xiaoyi_m')}${this.progress}%`
                  }
                  first=false;
                }
              })
            },3000)
      },
      lookAll:function() {
        this.userId = USER_INFO()._id;
        getPreView(this.user._id, this.docId).then(res=>{
          if(res.rc == 0){
            this.$refs.payvip.show({
                item:{
                  type:'pdf',
                  doc_id:this.docId,
                },
                data:res,
                userId:this.userId
             });
          }
        })
        this.status = 0;
      },
      showAlertError:function(des) {
        this.$message.error(des);
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/pdfview_pay.vue